import { Box, Button, Grid2, Typography, Autocomplete, TextField } from '@mui/material';
import { useState } from 'react';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import CustomDivider from '../../shared/utils/CustomDivider';
import AllCoursesCard from '../../shared/components/student/AllCoursesCard';
import { CircularButton } from '../../shared/utils/IconButton';
import { Grid_Gap } from '../../shared/constants';
import SearchInput from '../../shared/components/student/SearchInput';
import SelectBoxField from '../../shared/components/formfields/SelectBoxField';
import { useStudentCourse, useStudentOnlineCourses } from '../../assets/api/UseStudentGetApi';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import { GridChildren } from '../../shared/utils/LingtBlueContainer';
import TabsComponent from '../../shared/components/Tabs/TabComponent';
import TabPanel from '../../shared/components/Tabs/TabPanel';
import useTabs from '../../shared/hook/useTabs';




const RenderCourses = ({ studentcourses, isLoading }) => {
  const completedCourses = studentcourses?.filter(
    (item) => item.course_status === "Completed Class"
  );

  const ongoingCourses = studentcourses?.filter(
    (item) => item.course_status === "Ongoing Class"
  );

  const upcomingCourses = studentcourses?.filter(
    (item) => item.course_status === "Upcoming Class"
  );

  return (
    <>
      <NormalContainerWithHeader headerText={"Ongoing Courses"}>
        <Grid2 container spacing={Grid_Gap}>
          {!isLoading && (
            ongoingCourses?.length > 0 ? (
              ongoingCourses.map((item, index) => (
                <GridChildren index={index} key={index}>
                  <AllCoursesCard item={item} />
                </GridChildren>
              ))
            ) : (
              <Typography variant='body2'>No Ongoing Courses</Typography>
            )

          )}
          {
            isLoading && (
              [...Array(2)].map((_, index) => (
                <GridChildren index={index} key={index}>
                  <SkeletonCom />
                </GridChildren>
              ))
            )
          }
        </Grid2>
      </NormalContainerWithHeader>
      <CustomDivider orientation='horizontal' />
      <NormalContainerWithHeader headerText={"Upcoming Courses"} isGrid={false}>

        <Grid2 container spacing={Grid_Gap}>

          {!isLoading && (
            upcomingCourses?.length > 0 ? (
              upcomingCourses.map((item, index) => (
                <GridChildren index={index} key={index}>
                  <AllCoursesCard item={item} />
                </GridChildren>
              ))
            ) : (
              <Typography variant='body2'>No Upcoming  Courses</Typography>
            )

          )}
          {
            isLoading && (
              [...Array(2)].map((_, index) => (
                <GridChildren index={index} key={index}>
                  <SkeletonCom />
                </GridChildren>
              ))
            )
          }
        </Grid2>
      </NormalContainerWithHeader>
      <CustomDivider orientation='horizontal' />
      <NormalContainerWithHeader headerText={"Completed Courses"}>
        <Grid2 container spacing={Grid_Gap}>
          {!isLoading && (
            completedCourses?.length > 0 ? (
              completedCourses.map((item, index) => (
                <GridChildren index={index} key={index}>
                  <AllCoursesCard item={item} />
                </GridChildren>
              ))
            ) : (
              <Typography variant='body2'>No Completed Courses</Typography>
            )

          )}
          {
            isLoading && (
              [...Array(2)].map((_, index) => (
                <GridChildren index={index} key={index}>
                  <SkeletonCom />
                </GridChildren>
              ))
            )
          }
        </Grid2>
      </NormalContainerWithHeader>
    </>
  )
}


export const SearchSection = () => {
  return (
    <Grid2 container>
      <Grid2 children size={{ lg: 4, sm: 9, xs: 8 }}>
        <SearchInput />
      </Grid2>
      <Grid2 children size={{ lg: 8, sm: 3, xs: 4 }} display={"flex"} justifyContent={"end"} gap={"10px"}>
        <CircularButton icon={"weui:setting-outlined"} />
        <CircularButton icon={"iconamoon:notification"} />
      </Grid2>
    </Grid2>
  )
}

export const UseSelectBoxFeild = ({ label }) => {
  const courseCategories = [
    { value: 0, label: "apartment 1" },
    { value: 1, label: "apartment 2" },
    { value: 2, label: "apartment 3" },
    { value: 3, label: "apartment 4" },

  ];
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };
  return (
    <SelectBoxField
      label={label}
      options={courseCategories}
      isRequired={true}
      onChange={handleCategoryChange}
      value={selectedCategory}
    />
  )
}

const MyCourses = () => {
  const { value, handleChange } = useTabs(0);
  const { data: studentcourses, isLoading } = useStudentCourse({ is_event: 0 });
  const filteredCourses = studentcourses?.data?.filter(course => course.online !== 1);
  const { data: studentonlinecourses, isLoading: isOnlineCourseLoading } = useStudentOnlineCourses({ is_event: 0 });


  const tabsData = [
    { label: "Offline Classes", component: <RenderCourses studentcourses={filteredCourses} isLoading={isLoading} /> },
    { label: "Online Classes", component: <RenderCourses studentcourses={studentonlinecourses?.data} isLoading={isOnlineCourseLoading} /> }
  ];

  return (
    <Box>
      <CustomDivider orientation='horizontal' />

      <TabsComponent tabs={tabsData} value={value} onChange={handleChange} />
      {tabsData.map((tab, index) => (
        <TabPanel key={index} value={value} index={index}>
          {tab.component}
        </TabPanel>
      ))}

    </Box>
  );
}

export default MyCourses;